import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useAuth } from '@clerk/clerk-react';
import { Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/app')({
  component: AppLayout,
});

function AppLayout() {
  const { isSignedIn, isLoaded } = useAuth();

  // Show loading while Clerk initializes
  if (!isLoaded) {
    return <div className="terminal-status">Loading...</div>;
  }

  // Redirect to home if not signed in
  if (!isSignedIn) {
    return <Navigate to="/" />;
  }

  // Render child routes
  return <Outlet />;
}